import React from 'react';
import WorkHeader from './WorkHeader';

const WorkHero = ({ title, subtitle, badges, skills, image, alt }) => {
  return (
    <div className="min-h-screen mb-12">
      <WorkHeader 
        title={title}
        subtitle={subtitle}
        badges={badges}
        skills={skills}
      />
      
      {/* Hero image */}
      <div className="mt-10 mb-12">
        <div className="relative w-full aspect-[16/9]">
          <img 
            src={image} 
            alt={alt}
            className="absolute inset-0 w-full h-full object-cover rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default WorkHero; 